import React from 'react'
import "./Logout.css";
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify';
const Logout = (props) => {
  const navigate = useNavigate()
  const handlelogout = () => {
    window.localStorage.clear()
    props.setisLoggedIn(false);
    props.setModalShow1(false)
    toast.success("Admin Logout Successfully")
    navigate('/')
  }
  return (
    <>

      <Modal
        show={props.modalShow1}

        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header style={{ padding: "0px" }}>
          <div>
          </div>
        </Modal.Header>
        <Modal.Body>

          <div className="popup-box p-1 mt-5">
            <img src="assets/Vector.svg" />
            <h4 className="text-secondary mt-4">Are you sure you want to logout?</h4>
            <div className=" buton d-flex mt-4 justify-content-center">
              <button type="button" className="btn2" onClick={() => {
                props.setModalShow1(false)
              }}>Cancel</button>
              <button type="button" className="btn1" onClick={()=>{
                handlelogout()
              }}>Log out</button>
            </div>
          </div>

        </Modal.Body>
      </Modal>
    </>
  )
}
export default Logout;